const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBattery(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1826_13112",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 4,
    width: 30,
    height: 42
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.9517 4.16602H10.8333V45.8327H39.9517V4.16602Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1826_13112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.4734 24.9743H33.7134L23.3132 39.5341V29.1345H17.0732L27.4734 14.574V24.9743ZM23.3132 12.4942H14.9934V41.6139H35.7932V12.4942H27.4734V8.33404H23.3132V12.4942ZM19.153 8.33404V6.25424C19.153 5.70275 19.3718 5.17381 19.7624 4.7832C20.1524 4.3932 20.6813 4.17383 21.2334 4.17383H29.5532C30.7019 4.17383 31.633 5.10495 31.633 6.25363V8.33404H37.873C39.0217 8.33404 39.9528 9.26516 39.9528 10.4138V43.6943C39.9528 44.8429 39.0217 45.7741 37.873 45.7741H12.913C11.7643 45.7741 10.8332 44.8429 10.8332 43.6943V10.4138C10.8332 9.26516 11.7643 8.33404 12.913 8.33404H19.153Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBattery);
export default __webpack_public_path__ + "static/media/icon-battery.662788f3ca2fb18d0c01fa5c10389d1c.svg";
export { ForwardRef as ReactComponent };